// Military branch image mappings for agent profiles and listings

export const agentAssociations = {
  army: '/next/assets/images/in-service/army.png',
  navy: '/next/assets/images/in-service/navy.png',
  airforce: '/next/assets/images/in-service/air_force.png',
  marine: '/next/assets/images/in-service/marine_corps.png',
  coastguard: '/next/assets/images/in-service/coast_guard.png',
  space_force: '/next/assets/images/in-service/space_force.png',
};

 
export const militaryNameMapping = {
  Army: 'United States Army',
  Navy: 'United States Navy',
  'Air Force': 'United States Air Force',
  'Marine Corps': 'United States Marine Corps',
  'Coast Guard': 'United States Coast Guard',
  'Space Force': 'United States Space Force',
  'US Army': 'United States Army',
};

export const militaryBadgeMapping = {
  Army: 'army',
  Navy: 'navy',
  'Air Force': 'airforce',
  'Marine Corps': 'marine',
  'Coast Guard': 'coastguard',
  'Space Force': 'space_force',
  // Legacy mappings
  'US Army': 'army',
  'US Navy': 'navy',
  'US Air Force': 'airforce',
  'US Marine Corps': 'marine',
  'US Coast Guard': 'coastguard',
  'US Space Force': 'space_force',
};
  